<!-- Grid Settings Loading Indicator -->
<div class="grid-settings-status" *ngIf="id && !isSettingsLoaded">
    <app-loading-indicator 
        [loadingState$]="getLoadingState()" 
        [errorState$]="getErrorState()"
        loadingText="Loading grid settings...">
    </app-loading-indicator>
</div>

<!-- Grid placeholder when settings are loading -->
<div *ngIf="id && !isSettingsLoaded" class="grid-placeholder">
    <div class="placeholder-content">
        <div class="loading-spinner"></div>
        <p>Loading grid configuration...</p>
    </div>
</div>

<!-- Actual Grid - always render but hide data until settings loaded -->
<ag-grid-angular
    #grid
    class="ag-theme-material ag-theme-quartz w-100 h-100 "
    [rowData]="(!id || isSettingsLoaded) ? rowData : []"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [rowSelection]="rowSelection"
    [groupSelectsChildren]="groupSelectsChildren"
    [suppressRowClickSelection]="suppressRowClickSelection"
    [rowMultiSelectWithClick]="rowMultiSelectWithClick"
    [pagination]="pagination"
    [paginationPageSize]="paginationPageSize"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [suppressPaginationPanel]="suppressPaginationPanel"
    [suppressNoRowsOverlay]="suppressNoRowsOverlay"
    [suppressDragLeaveHidesColumns]="suppressDragLeaveHidesColumns"
    [rowModelType]="rowModelType"
    [rowHeight]="rowHeight"
    [headerHeight]="headerHeight"
    [serverSideDatasource]="serverSideDatasource"
    [enableRtl]="enableRtl"
    [cacheBlockSize]="paginationPageSize"
    [enableRangeSelection]="enableRangeSelection"
    [undoRedoCellEditing]="undoRedoCellEditing"
    [undoRedoCellEditingLimit]="undoRedoCellEditingLimit"
    [enableCellChangeFlash]="enableCellChangeFlash"
    [enableFillHandle]="enableFillHandle"
    [suppressClickEdit]="suppressClickEdit"
    [maxBlocksInCache]="maxBlocksInCache"
    [cacheOverflowSize]="cacheOverflowSize"
    [groupDefaultExpanded]="groupDefaultExpanded"
    [editType]="editType"
    [localeText]="localeText"
    [singleClickEdit]="singleClickEdit"
    [rowGroupPanelShow]="rowGroupPanelShow"
    [gridOptions]="gridOptions"
    (firstDataRendered)="firstDataRenderedExtra($event)"
    (cellEditingStopped)="cellEditingStopped.emit($event)"
    (rowEditingStopped)="rowEditingStopped.emit($event)"
    (gridReady)="gridReadyExtra($event)"
    (cellClicked)="cellClicked.emit($event)"
    (rowClicked)="rowClickedExtra($event)"
    (rowDoubleClicked)="rowDoubleClicked.emit($event)"
    (paginationChanged)="paginationChanged.emit($event)"
    (rowDataUpdated)="rowDataUpdated.emit($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (rowValueChanged)="rowValueChanged.emit($event)"
    (cellValueChanged)="cellValueChanged.emit($event)"
    (cellDoubleClicked)="cellDoubleClicked.emit($event)"
    (modelUpdated)="modelUpdated.emit($event)"
    (rowSelected)="rowSelected.emit($event)"
    
></ag-grid-angular>